export default "__VITE_ASSET__96a1016b__"